module.exports = __webpack_public_path__ + "media/images/talent/feature-02-56a7df5e05d8c41e6c71613dd81e9f9b.svg";